import { FilterKey, FilterKeyType, FilterValueType } from './types/types'; // Adjust import path
import { getOutlierWeeksList } from './helpers';

export const createFilterChangeHandler = (
  onFilterChange: (filters: Partial<FilterValueType>) => void
) => {
  return <K extends FilterKeyType>(
    singleKeyOrMultiFilters: K | Partial<FilterValueType>,
    value?: FilterValueType[K]
  ) => {
    // If second parameter is undefined, treat first parameter as filters object for multi-valued filtering
    if (value === undefined && typeof singleKeyOrMultiFilters === 'object') {
      onFilterChange(singleKeyOrMultiFilters);
      return;
    }

    // Otherwise, handle as single key-value pair
    const key = singleKeyOrMultiFilters as K;

    switch (key) {
      case FilterKey.CATEGORY:
        onFilterChange({
          category: value as FilterValueType[typeof FilterKey.CATEGORY],
        });
        break;
      case FilterKey.STATUS:
        onFilterChange({
          status: value as FilterValueType[typeof FilterKey.STATUS],
        });
        break;
      case FilterKey.ASSOCIATE:
        onFilterChange({
          associate: value as FilterValueType[typeof FilterKey.ASSOCIATE],
        });
        break;
      case FilterKey.TM:
        onFilterChange({
          tm: value as FilterValueType[typeof FilterKey.TM],
        });
        break;
      case FilterKey.TIME_OPTION:
        onFilterChange({
          timeOption: value as FilterValueType[typeof FilterKey.TIME_OPTION],
        });
        break;

      case FilterKey.TIME_OPTIONS:
        onFilterChange({
          timeOptions: value as FilterValueType[typeof FilterKey.TIME_OPTIONS],
        });
        break;
      case FilterKey.VIEW_DATA_BY:
        onFilterChange({
          viewDataBy: value as FilterValueType[typeof FilterKey.VIEW_DATA_BY],
        });
        break;
    }
  };
};

export const getWeeksListForFilter = (): string[] => {
  const allWeeks = getOutlierWeeksList();
  // Skip current week as there is no outlier data for the current week,
  // get the previous 3 weeks.
  return allWeeks.slice(1, 4);
};

export const getWeekRangeFromWeekList = (
  weekList: string[]
): [string, string] => {
  if (weekList.length <= 1) {
    throw new Error(
      'Week list size cannot be empty smaller than or equal to 1'
    );
  }

  // clonning the list through the spread operator to avoid mutating the input list
  const sortedWeekList = [...weekList].sort();

  const firstWeek = sortedWeekList[0];
  const lastWeek = sortedWeekList[weekList.length - 1];

  return [firstWeek, lastWeek];
};
